
export class TableUser {
    constructor(
        public email: string,
        public roles: string[],
        public teams: string[],
        public isBlocked: boolean,
    ) { }
}